import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";

import CreateMerchantDetails from "../components/create/CreateMerchantDetails";
import CreateMerchantIdentification from "../components/create/CreateMerchantIdentification";
import CreateMerchantGateway from "../components/create/CreateMerchantGateway";
import CreateMerchantRatesv2 from "../components/create/CreateMerchantRatesv2";

import { createMerchantv2 } from "../../../libs/functions";
import Util from "../../../libs/util";
import Swal from "sweetalert2";

class CreateMerchantModal extends React.Component {
	constructor(props) {
		super(props);

		const { MDRTypes, gateway } = props;
		const mdrs = this.getMdrs();
		const mdrs_enable = this.getMdrsEnable();

		const gateway_enable = Object.keys(gateway).reduce((result, key) => {
			if (!result[key]) result[key] = {};
			for (let type in MDRTypes) {
				result[key][type] = false;
			}
			return result;
		}, {});

		this.state = {
			initialValues: {
				name: "",
				receiptName: "",
				statementName: "",
				mid: "",
				users: "",
				rates: mdrs,
				enable: mdrs_enable,
				accepted: { ...gateway_enable },
				reseller: "",
				requireSignature: true,
				mcc: 5812,
			},
			enable: mdrs_enable,
			accepted: { ...gateway_enable },
			currencyList: [
				{ code: 702, name: "SGD" },
				{ code: 458, name: "MYR" },
				{ code: 764, name: "THB" },
				{ code: 360, name: "IDR" },
			],
			defaultMdrs: mdrs,
			defaultEnable: mdrs_enable,
			selectedReseller: undefined,
		};

		this.validation = Yup.object({
			name: Yup.string().required("Name is required"),
			mid: Yup.string().required("MID is required"),
			reseller: Yup.string().required("Reseller is required"),
		});
	}

	componentDidUpdate(prevProps) {
		if (
			JSON.stringify(prevProps.baseRate) !== JSON.stringify(this.props.baseRate)
		) {
			const mdrs = this.getMdrs();
			const updateInitial = {
				...this.state.initialValues,
				...(this.state.selectedReseller && {
					reseller: this.state.selectedReseller,
				}),
			};
			updateInitial.rates = mdrs;
			this.setState({ initialValues: updateInitial, defaultMdrs: mdrs });
		}
	}

	getMdrs = () => {
		const { MDRTypes, baseRate } = this.props;
		let mdrs = {};
		let gateways = Object.keys(baseRate);
		for (let gateway of gateways) {
			if (gateway !== "stripe") {
				let targetRates = Object.entries(baseRate[gateway]);
				let result = targetRates.reduce((acc, [currency, mdr]) => {
					// if (currency === "702") {
					const filtered = Object.keys(MDRTypes).reduce((acc, paymentType) => {
						if (mdr[paymentType]) acc[paymentType] = mdr[paymentType];
						return acc;
					}, {});

					acc[currency] = filtered;
					// }
					return acc;
				}, {});
				mdrs[gateway] = result;
			} else mdrs[gateway] = baseRate[gateway];
		}

		// Remove non-MDR payment channels
		Object.keys(mdrs).forEach((currency) => {
			Object.keys(mdrs[currency]).forEach((paymentType) => {
				if (!mdrs[currency][paymentType]) delete mdrs[currency][paymentType];
			});
		});

		return mdrs;
	};

	getMdrsEnable = () => {
		const { MDRTypes, baseRate } = this.props;
		let mdrs_enable = {};
		let gateways = Object.keys(baseRate);
		for (let gateway of gateways) {
			if (gateway === "ipay88") {
				const result = Object.keys(MDRTypes).reduce((result, key) => {
					if (baseRate[gateway][458][key]) result[key] = false;
					return result;
				}, {});

				if (!mdrs_enable[gateway]) mdrs_enable[gateway] = {};
				mdrs_enable[gateway][458] = result;
			} else if (gateway !== "stripe") {
				const result = Object.keys(MDRTypes).reduce((result, key) => {
					if (baseRate[gateway]?.[702]?.[key]) {
						result[key] = false;
					}
					return result;
				}, {});

				if (!mdrs_enable[gateway]) mdrs_enable[gateway] = {};
				mdrs_enable[gateway][702] = result;
			} else {
				const { default: defaultRate, under, ...rest } = baseRate[gateway];
				if (Object.keys(rest).length > 0) {
					mdrs_enable[gateway] = {};
					for (let key in rest) {
						mdrs_enable[gateway].default = false;
						mdrs_enable[gateway][key] = false;
					}
				}
			}
		}
		return mdrs_enable;
	};

	closeModal = () => {
		return Util.hideModal(`${this.props.id}`);
	};

	handleCreate = (values, { setSubmitting, resetForm }) => {
		Swal.fire({
			title: "Creating Merchant",
			onBeforeOpen: () => {
				this.closeModal().then(() => {
					resetForm();
				});
				Swal.showLoading();
			},
			onOpen: async () => {
				try {
					const data = await createMerchantv2(values);
					const text = await data.text();
					const { merchant, pendingUsers, existingUsers, certs } =
						JSON.parse(text);
					Swal.hideLoading();
					let responseAlerts = [];

					if (certs) {
						certs.forEach(({ mid, cert }) => {
							Util.downloadFile(cert, `cert.crt - ${mid}.txt`);
						});
					}
					if (merchant) {
						setSubmitting(false);
						responseAlerts.push({
							icon: "success",
							title: "Merchant Created",
						});
					}
					if (pendingUsers.length > 0) {
						responseAlerts.push({
							icon: "info",
							title: "Pending Users",
							text: `Setup email sent to ${pendingUsers.join(",")}`,
						});
					}
					if (existingUsers.length > 0) {
						responseAlerts.push({
							icon: "error",
							title: "Unable to add Users",
							text: `Account already exist for ${existingUsers.join(",")}`,
						});
					}
					Swal.mixin({
						confirmButtonText: responseAlerts > 1 ? "Next &rarr;" : "Confirm",
					})
						.queue(responseAlerts)
						.then((result) => {
							if (result.value) {
								this.props.retrieveMerchants();
							}
						});
				} catch (err) {
					setSubmitting(false);
					if (err.response && err.response.status === 401) {
						Util.expireSession().then(() => {
							window.location = "/login";
						});
					} else {
						Swal.fire({
							icon: "error",
							title: `Unable to Create Merchant`,
							onClose: () => {},
						});
						console.log(err);
					}
				}
			},
		});
	};

	enableRate = (prefix, value) => {
		let { enable } = this.state;
		let split = prefix.split(".");
		if (split[0] !== "stripe") {
			let [gateway, currency, type] = split;
			enable[gateway][currency][type] = value;
		} else {
			let [gateway, type] = split;
			enable[gateway][type] = value;
		}
		this.setState({ enable: enable });
	};

	setGatewayRates = (config, enable) => {
		let update = { ...this.state.enable };
		let { gateway, currency } = config;

		let target = update[gateway];
		if (gateway !== "stripe") target = target[currency];
		for (let key in target) {
			target[key] = enable;
		}

		this.setState({ enable: update });
	};

	acceptType = (gateway, type, value) => {
		let { accepted } = this.state;
		accepted[gateway][type] = value;
		this.setState({ accepted: accepted });
	};

	newMID = (gateway, count) => {
		let { initialValues } = this.state;

		if (!initialValues[gateway]) initialValues[gateway] = { code: {}, mid: {} };

		for (let i = 0; i < count; i++) {
			if (!initialValues[gateway].code[i]) initialValues[gateway].code[i] = "";
			if (!initialValues[gateway].mid[i]) initialValues[gateway].mid[i] = "";
		}

		this.setState({ initialValues });
	};

	addCurrency = (gateway, currency) => {
		const { MDRTypes, baseRate } = this.props;
		let current = { ...this.state.enable };
		current = {
			...current,
			[gateway]: {
				...current[gateway],
				[currency.value]: { ...this.state.defaultEnable[gateway][702] },
			},
		};
		this.setState({ enable: current });

		let targetRates = Object.entries(baseRate[gateway]);
		let result = targetRates.reduce((acc, [target, mdr]) => {
			if (String(target) === String(currency.value)) {
				const filtered = Object.keys(MDRTypes).reduce((acc, paymentType) => {
					if (mdr[paymentType]) acc[paymentType] = mdr[paymentType];
					return acc;
				}, {});

				acc[currency.value] = filtered;
			}
			return acc;
		}, {});

		let { initialValues } = this.state;
		initialValues.rates[gateway] = {
			...initialValues.rates[gateway],
			...result,
		};
		initialValues.enable[gateway] = {
			...initialValues.enable[gateway],
			[currency.value]: { ...this.state.defaultEnable[gateway][702] },
		};
		this.setState({ initialValues: initialValues });
	};

	updateReseller = (reseller) => {
		this.setState({ selectedReseller: reseller });
		this.props.retrieveBaseRate(reseller);
	};

	render() {
		const { initialValues, enable, accepted, currencyList } = this.state;
		const { MDRTypes, gateway, resellers, retrieveBaseRate, baseRate } =
			this.props;

		return (
			<div id={this.props.id} className="uk-modal-full" uk-modal="">
				<div className="uk-modal-dialog">
					<button
						className="uk-modal-close-full uk-close-large"
						type="button"
						uk-close=""
					/>
					<div className="uk-padding" style={{ paddingTop: 30 }}>
						<h3>
							<span className="uk-flex uk-flex-middle">
								<i
									className="uk-margin-small-right form-header-icon"
									uk-icon="icon: fa-solid-store-alt"
								/>
								Create Merchant
							</span>
						</h3>
						<Formik
							initialValues={initialValues}
							// validationSchema={this.validation}
							enableReinitialize={true}
							onSubmit={this.handleCreate}
						>
							<Form className="uk-grid uk-grid-divider">
								<div className="uk-width-2-5@l">
									<CreateMerchantDetails
										resellers={resellers}
										retrieveBaseRate={retrieveBaseRate}
										updateReseller={this.updateReseller}
									/>
									<CreateMerchantIdentification
										gateway={gateway}
										newMID={this.newMID}
									/>
									{/* <CreateMerchantUsers /> */}
								</div>
								<div className="uk-width-3-5@l">
									<div className="uk-flex uk-flex-column">
										<CreateMerchantGateway
											gateway={gateway}
											MDRTypes={MDRTypes}
											accepted={accepted}
											acceptType={this.acceptType}
										/>
										<CreateMerchantRatesv2
											gateway={gateway}
											MDRTypes={MDRTypes}
											enable={enable}
											enableRate={this.enableRate}
											currencyList={currencyList}
											addCurrency={this.addCurrency}
											baseRate={baseRate}
											setGatewayRates={this.setGatewayRates}
										/>
									</div>
									<p className="uk-text-right">
										<button
											className="uk-button uk-button-default uk-modal-close"
											type="button"
										>
											Cancel
										</button>
										<button
											className="uk-button uk-button-primary"
											type="submit"
										>
											Create
										</button>
									</p>
								</div>
							</Form>
						</Formik>
					</div>
				</div>
			</div>
		);
	}
}

export default CreateMerchantModal;
